import React from 'react'

const TwoFactorAuthentication = () => {
  return (
    <>
      <section>
        <h1>Two Factor Authentication</h1>
      </section> 
    </>
  )
}

export default TwoFactorAuthentication
